// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discount-card {
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  background: linear-gradient(56deg, rgb(35, 107, 254) 35%, rgb(35, 159, 254) 100%);
  margin-bottom: 24px;
  position: relative;
}
.discount-card .main-info h2 {
  font-size: 20px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.5px;
}
.discount-card .main-info p {
  color: rgba(255, 255, 255, 0.7490196078);
  font-size: 16px;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.discount-card .logo {
  position: absolute;
  right: 30px;
  width: 40px;
  filter: brightness(0) invert(1);
}
.discount-card .code {
  font-weight: 600;
  color: white;
  letter-spacing: 6px;
}

.table-container {
  margin: 0 -24px !important;
}

.discount-value {
  background: linear-gradient(45deg, #d1d1d1, #a8a8a8, #e1e1e1);
  color: transparent;
  font-weight: bold;
  font-size: 4rem;
  background-clip: text;
}

.discount-wrapper {
  display: flex;
  align-items: flex-end;
}

@media (min-width: 576px) {
  .code {
    font-size: 3rem;
  }
}
@media (max-width: 576px) {
  .discount-value {
    font-size: 1rem;
  }
  .code {
    font-size: 1rem;
  }
  .main-info h1 {
    font-size: 28px;
  }
  .main-info h2 {
    font-size: 18px;
  }
  .main-info p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/discount-card/discount-card-details/discount-card-details.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAEI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AAAN;AAGI;EACE,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AADN;AAKE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;AAHJ;AAKE;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,6DAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;EACA,qBAAA;AAJF;;AAOA;EACE;IACE,eAAA;EAJF;AACF;AAOA;EACE;IACE,eAAA;EALF;EAOA;IACE,eAAA;EALF;EAOA;IACE,eAAA;EALF;EAQA;IACE,eAAA;EANF;EASA;IACE,eAAA;EAPF;AACF","sourcesContent":[".discount-card {\n  border-radius: 16px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: auto;\n  background: linear-gradient(56deg, rgba(35, 107, 254, 1) 35%, rgba(35, 159, 254, 1) 100%);\n  margin-bottom: 24px;\n  position: relative;\n\n  .main-info {\n    h2 {\n      font-size: 20px;\n      font-weight: 600;\n      color: white;\n      letter-spacing: 0.5px;\n    }\n\n    p {\n      color: #ffffffbf;\n      font-size: 16px;\n      letter-spacing: 0.5px;\n      margin-bottom: 4px;\n    }\n  }\n\n  .logo {\n    position: absolute;\n    right: 30px;\n    width: 40px;\n    filter: brightness(0) invert(1);\n  }\n  .code {\n    font-weight: 600;\n    color: white;\n    letter-spacing: 6px;\n  }\n}\n\n.table-container {\n  margin: 0 -24px !important;\n}\n\n.discount-value {\n  background: linear-gradient(45deg, #d1d1d1, #a8a8a8, #e1e1e1);\n  color: transparent;\n  font-weight: bold;\n  font-size: 4rem;\n  background-clip: text;\n}\n\n.discount-wrapper {\n  display: flex;\n  align-items: flex-end;\n}\n\n@media (min-width: 576px) {\n  .code {\n    font-size: 3rem;\n  }\n}\n\n@media (max-width: 576px) { \n  .discount-value {\n    font-size: 1rem; \n  }\n  .code {\n    font-size: 1rem;\n  }\n  .main-info h1 {\n    font-size: 28px; \n  }\n\n  .main-info h2 {\n    font-size: 18px;\n  }\n\n  .main-info p {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
